<template>
  <Popup
    :title="'已授权应用'"
    :visible="visible"
    :singleBtn="true"
    @popupCancle="checkApp"
    @popupOk="checkApp"
  >
    <a-table
      size="middle"
      bordered
      :columns="columns"
      :data-source="dataList"
      rowKey="id"
      :scroll="{ x: 1200 }"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange"
    >
    </a-table>
  </Popup>
</template>

<script>
import Popup from '@/components/common/Popup';
import { getAction } from '@/api/manage';
const columns = [
  {
    align: 'center',
    title: '系统名',
    dataIndex: 'systemName',
    width: 200
  },
  {
    align: 'center',
    title: '系统id',
    dataIndex: 'systemCode',
    width: 200
  },
  {
    align: 'center',
    title: '频率限制类型',
    dataIndex: 'rateLimitType',
    width: 200,
    customRender: text => {
      if (!text || text == '') {
        return '--';
      } else {
        return text == 0 ? '不限制' : text == 1 ? '静态' : '动态';
      }
    }
  },
  {
    align: 'center',
    title: '频率',
    dataIndex: 'rate',
    width: 200
  },
  {
    align: 'center',
    title: '单位',
    dataIndex: 'rateUnit',
    width: 200
  },
  {
    align: 'center',
    title: '是否加密',
    dataIndex: 'isEncrypt',
    width: 100,
    customRender: text => {
      console.warn(!text, text == '');
      if (text + '' == '') {
        return '--';
      } else {
        return text == 0 ? '否' : '是';
      }
    }
  }
];
export default {
  data() {
    return {
      visible: false,
      columns,
      dataList: [],
      loading: false,
      ipagination: {
        //分页参数
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      getAuthApp:
        process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/interface/app/page',
      interfaceId: ''
    };
  },
  components: {
    Popup
  },
  methods: {
    initData(record) {
      this.interfaceId = record ? record.id : this.interfaceId;
      let params = {
        interfaceId: this.interfaceId,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      };
      this.loading = true;
      getAction(this.getAuthApp, params).then(res => {
        this.loading = false;
        if (res.success) {
          this.dataList =
            res.result && res.result.records ? res.result.records : [];
          this.ipagination.total = res.result ? res.result.total : 0;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    checkApp() {
      this.visible = !this.visible;
    },
    handleTableChange(pagination, filters, sorter) {
      this.ipagination = pagination;
      this.initData();
    }
  }
};
</script>
